export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Tipo comrobante AFIP',
	plural_model_name_spanish: 'Tipo comrobante AFIP',
	create_model_name_spanish: 'Nueva Tipo comrobante AFIP',
	text_delete: 'la',
}